/* tslint:disable */
/* eslint-disable */
/**
 * RX360-WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SubSpecialtiesEnum = {
    Endocrinology: 'Endocrinology',
    Git: 'GIT',
    Neurology: 'Neurology',
    Cardiology: 'Cardiology',
    Nephrology: 'Nephrology',
    Pulmonology: 'Pulmonology',
    HematologyOncology: 'Hematology / Oncology',
    Icu: 'ICU',
    BariatricSurgery: 'Bariatric Surgery',
    AdultSurgicalOncology: 'Adult Surgical Oncology',
    AnteriorSegmentSurgery: 'Anterior segment surgery',
    CorneaOcularSurfaceAndExternalDisease: 'Cornea, ocular surface, and external disease',
    Glaucoma: 'Glaucoma',
    OculoplasticsAndOrbitSurgery: 'Oculoplastics and orbit surgery',
    PediatricOphthalmologyStrabismus: 'Pediatric ophthalmology/strabismus',
    MedicalRetina: 'Medical Retina',
    RefractiveSurgery: 'Refractive surgery',
    VitreoRetinalSurgery: 'Vitreo-retinal surgery',
    InterventionalCardiology: 'Interventional Cardiology',
    Neurophysiology: 'Neurophysiology',
    EpilepsyFellowship: 'Epilepsy Fellowship',
    FellowshipInCancerScreening: 'Fellowship in Cancer Screening',
    ClinicalNutritionFellowship: 'Clinical Nutrition Fellowship',
    OccupationalHealthFellowship: 'Occupational Health Fellowship',
    FellowshipInAdultHealth: 'Fellowship in Adult Health',
    FellowshipInMentalHealth: 'Fellowship in Mental Health',
    FellowshipInEpidemiologyOfCommunicableDiseases: 'Fellowship in Epidemiology of Communicable Diseases',
    DisasterMedicineFellowship: 'Disaster Medicine Fellowship',
    AviationMedicineFellowship: 'Aviation Medicine Fellowship',
    FellowshipInAutismCare: 'Fellowship in Autism Care',
    FellowshipInSpineSurgery: 'Fellowship in Spine Surgery',
    FellowshipInCardiacSurgery: 'Fellowship in Cardiac Surgery',
    FellowshipOfSkullBaseSurgery: 'Fellowship of Skull Base Surgery',
    FellowshipOfLateralSkullBaseSurgery: 'Fellowship of Lateral Skull Base Surgery',
    FellowshipInGynecologicalOncology: 'Fellowship in Gynecological Oncology',
    FellowshipInFertilityAndAssistedReproductionTechniques: 'Fellowship in Fertility and Assisted Reproduction Techniques',
    FellowshipInEndoscopicTreatmentOfKidneyStones: 'Fellowship in Endoscopic Treatment of Kidney Stones',
    FellowshipInKidneyTransplantation: 'Fellowship in Kidney Transplantation',
    FellowshipInCriticalCare: 'Fellowship in Critical Care',
    FellowshipInCardiacAnesthesia: 'Fellowship in Cardiac Anesthesia',
    InterventionalRadiology: 'Interventional Radiology',
    BreastImaging: 'Breast Imaging'
} as const;
export type SubSpecialtiesEnum = typeof SubSpecialtiesEnum[keyof typeof SubSpecialtiesEnum];


export function instanceOfSubSpecialtiesEnum(value: any): boolean {
    return Object.values(SubSpecialtiesEnum).includes(value);
}

export function SubSpecialtiesEnumFromJSON(json: any): SubSpecialtiesEnum {
    return SubSpecialtiesEnumFromJSONTyped(json, false);
}

export function SubSpecialtiesEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubSpecialtiesEnum {
    return json as SubSpecialtiesEnum;
}

export function SubSpecialtiesEnumToJSON(value?: SubSpecialtiesEnum | null): any {
    return value as any;
}

